function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.4169 15.7071C12.8074 16.0976 13.4406 16.0976 13.8311 15.7071C14.2217 15.3166 14.2217 14.6834 13.8311 14.2929L12.4169 15.7071ZM13.8311 5.70711C14.2217 5.31658 14.2217 4.68342 13.8311 4.29289C13.4406 3.90237 12.8074 3.90237 12.4169 4.29289L13.8311 5.70711ZM13.8311 14.2929L9.18468 9.64645L7.77047 11.0607L12.4169 15.7071L13.8311 14.2929ZM9.18468 10.3536L13.8311 5.70711L12.4169 4.29289L7.77047 8.93934L9.18468 10.3536ZM9.18468 9.64645C9.37995 9.84171 9.37994 10.1583 9.18468 10.3536L7.77047 8.93934C7.18468 9.52512 7.18468 10.4749 7.77047 11.0607L9.18468 9.64645Z",
  fill: "#767B87"
});

const SvgCaret = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCaret, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/caret.283aeefd.svg";
export { ForwardRef as ReactComponent };